import React from "react";
import { Row, Col, Card, CardBody, CardHeader } from "reactstrap";

import transactions from "../../api/transactions";
import reports from "../../api/reports";

import TransactionsTable from "../Components/TransactionsTable";
import TableContainerWithLocation from "../Components/TableContainerWithLocation";

const OutgoingTransaction = () => (
  <div className="animated fadeIn">
    <Row>
      <Col>
        <Card>
          <CardHeader>Outgoing Transactions</CardHeader>
          <CardBody>
            <TableContainerWithLocation
              loadData={transactions.getOutgoingTransactions}
              requestReport={reports.requestOutgoingTransactions}>
              <TransactionsTable type="outgoing" />
            </TableContainerWithLocation>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

export default OutgoingTransaction;
